import { merge } from 'lodash'
import { BasicConfig } from './basic-config'
export const echartsType = 'Bar'

const dataZoomY = [
  {
    // 设置滚动条的隐藏或显示
    show: true,
    // 设置类型
    type: 'slider',
    // 设置选中范围的填充颜色
    fillerColor: 'rgba(118, 83, 214, .4)',
    borderColor: 'transparent',
    // 滚动条高度
    width: 4,
    right: 2,
    // 是否显示detail，即拖拽时候显示详细数值信息
    showDetail: false,
    // 数据窗口范围的起始数值
    startValue: 0,
    // 数据窗口范围的结束数值（一页显示多少条数据）
    endValue: 5,
    // 控制哪个轴，如果是number表示控制一个轴，
    // 如果是Array表示控制多个轴。此处控制第二根轴
    yAxisIndex: [0, 1],
    // 即不会影响其他轴的数据范围
    filterMode: 'empty',
    showDataShadow: false, // 是否显示数据阴影
    realtime: true, // 是否实时更新
    brushSelect: false,
    handleSize: 0,
    moveHandleStyle: {
      borderWidth: 100
    }
  },
  {
    // 鼠标滚轮在区域内不能控制外部滚动条
    type: 'inside',
    yAxisIndex: [0, 1],
    // 滚轮是否触发缩放
    zoomOnMouseWheel: false,
    // 鼠标移动能否触发平移
    moveOnMouseMove: true,
    // 鼠标滚轮能否触发平移
    moveOnMouseWheel: true,
  },
]

export class Bar extends BasicConfig {
  constructor(options) {
    super(options)
    this.init(options)
  }
  init(options) {
    const { code } = options
    this.code = code
    this.initLegend()
    this.initSeries(options)
    this.initTooltip()
    this.initXAxis()
    this.initYAxis(options)
    this.initDataZoom()
    this.initGrid()
    this.initOption(options)
  }
  initOption(options) {
    const { series, color, legend, tooltip, xAxis, yAxis, grid, dataZoom } = this
    const option = {
      title: {
        show: false,
      },
      series,
      color,
      legend,
      tooltip,
      xAxis,
      yAxis,
      grid,
      dataZoom,
    }
    this.option = option
  }
  initSeries(options) {
    const { data, propsConfig } = options
    const { value } = propsConfig
    const _data = data.map(item => item[value || 'value'])
    this.series = merge(this.series,
      [{
        name: 'kye-bar',
        type: 'bar',
        barWidth: 12,
        label: {
          show: true,
          position: 'right',
          color: '#666666',
        },
        itemStyle: {
          normal: {
            barBorderRadius: [0, 2, 2, 0],
            color: '#8e88ff'
          }
        },
        data: _data
      }
    ])
  }
  initDataZoom() {
    this.dataZoom = merge(this.dataZoom, dataZoomY)
  }
  initXAxis() {
    const { code } = this
    this.xAxis = merge(this.xAxis, {
      type: 'value',
      show: !!code.includes('001'),
      boundaryGap: [0, 0.01],
      axisLabel: {
        color: '#666',
      },
      splitLine: {
        show: !!code.includes('001'),
        lineStyle: {
          color: '#F0F0F2',
          type: 'dashed'
        }
      },
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      },
    })
  }
  initYAxis(options) {
    const { data, propsConfig } = options
    const { label } = propsConfig
    const _data = data.map(item => item[label || 'label'])
    this.yAxis = merge(this.yAxis, {
      type: 'category',
      data: _data,
      triggerEvent: true,
      axisLabel: {
        color: '#666',
        formatter: null
      },
      axisLine: {
        lineStyle: {
          color: '#bfbfbf'
        }
      },
      axisTick: {
        show: false
      },
    })
  }
  initTooltip() {
    this.tooltip = merge(this.tooltip, {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow',
        color: '#F2F3F7',
        z: 0,
        label: {
          show: true,
          color: '#fff',
          backgroundColor: '#FF9300',
        },
      },
      triggerTooltip: false,
      backgroundColor: '#fff',
      padding: 0,
      formatter: () => {
        return ''
      }
    })
  }
  initLegend() {
    this.legend = merge(this.legend, {
      show: false
    })
  }
  initGrid() {
    this.grid = merge(this.grid, {
      top: '16',
      left: '30',
      right: '95',
      bottom: '15',
      containLabel: true
    })
  }
}
Bar.echartsType = echartsType



// WEBPACK FOOTER //
// ./src/public/components/kye-report-form/echarts/common/basic/bar.js